// extracted by mini-css-extract-plugin
export default {"popularcard":"slider_card_popularcard__UGd0Y","popularcard__img":"slider_card_popularcard__img__5GOqp","popularcard__title":"slider_card_popularcard__title__9HwI4"};